var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _dec33, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

/**
 * @copyright
 * Copyright(c) 2020 SICK AG
 */
import { Component, html, Prop, Watch } from '@sick-davinci/ce-decorators';
import * as QuickChart from '@meistercharts/meistercharts';
import { style } from './LineChart.style';
import { LineChartLayout } from './LineChartLayout.js';
import { CssTools } from '../_utils/CssTools.js';
import { ArrayTools } from '../_utils/ArrayTools.js';
import { isColor, resolveCssColor, toCssColorValue } from '../_utils/ColorTools.js';
import { computeThresholds } from '../_utils/Thresholds.js';
import { ValueAxisBuilder } from '../_utils/ValueAxisBuilder.js';
import { CategoryAxisBuilder } from '../_utils/CategoryAxisBuilder.js';
import { ValueRangeScale } from '../_utils/ValueRange.js';
import { ValueRangeTools } from '../_utils/ValueRangeTools.js';
import { ThemeService } from '../_utils/ThemeService.js';
import { createCategoriesGridStyle, createValuesGridStyle, sanitizeGridVisibility } from '../_utils/GridTools.js';
import { createBalloonTooltipStyle } from '../_utils/TooltipTools.js';
import { LegendGrid } from '../legend/LegendGrid.js';
import { AbstractChart } from '../_utils/AbstractChart.js';
import { sanitizeJustifyContent } from '../_utils/JustifyContent.js';
import { safeNumberArrays } from '../_utils/SanitizeTools.js';
/**
 * PointType for a LineChart (subset of quickchart types)
 */

const symbolMap = {
  Continuous: 'line',
  None: 'disc',
  // connection points only
  LargeDashes: 'large_dashed_line',
  SmallDashes: 'small_dashed_line',
  Dotted: 'dotted_line'
};
/**
 * A simple line chart
 *
 * @example
 * ```
 * <davinci-element-container heading="LineChart" style="width: 400px; height: 300px">
 *  <davinci-line-chart values="[[95, 96, 98, 82, 97, 98, 72]]"></davinci-line-chart>
 * </davinci-element-container>
 * ```
 */

export let LineChart = (_dec = Component({
  tag: 'davinci-line-chart',
  style,
  dependencies: [LegendGrid]
}), _dec2 = Prop(), _dec3 = Reflect.metadata("design:type", Object), _dec4 = Prop(), _dec5 = Reflect.metadata("design:type", Object), _dec6 = Prop(), _dec7 = Reflect.metadata("design:type", Object), _dec8 = Watch('visibleLines'), _dec9 = Reflect.metadata("design:paramtypes", []), _dec10 = Prop(), _dec11 = Reflect.metadata("design:type", Boolean), _dec12 = Prop(), _dec13 = Reflect.metadata("design:type", Object), _dec14 = Prop(), _dec15 = Reflect.metadata("design:type", Object), _dec16 = Prop(), _dec17 = Reflect.metadata("design:type", Boolean), _dec18 = Watch('noTooltip'), _dec19 = Reflect.metadata("design:paramtypes", []), _dec20 = Prop(), _dec21 = Reflect.metadata("design:type", Number), _dec22 = Prop({
  reflectAsAttribute: false
}), _dec23 = Reflect.metadata("design:type", Number), _dec24 = Watch('axisWidth'), _dec25 = Reflect.metadata("design:paramtypes", []), _dec26 = Prop(), _dec27 = Reflect.metadata("design:type", Object), _dec28 = Prop({
  type: String
}), _dec29 = Reflect.metadata("design:type", Object), _dec30 = Prop(), _dec31 = Reflect.metadata("design:type", Object), _dec32 = Watch('palette'), _dec33 = Reflect.metadata("design:paramtypes", []), _dec(_class = (_class2 = class LineChart extends AbstractChart {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "_values", []);

    _initializerDefineProperty(this, "visibleLines", _descriptor, this);

    _initializerDefineProperty(this, "interactiveLegend", _descriptor2, this);

    _defineProperty(this, "_userDefinedLineStyles", []);

    _initializerDefineProperty(this, "noTooltip", _descriptor3, this);

    _initializerDefineProperty(this, "axisWidth", _descriptor4, this);

    _defineProperty(this, "_grid", 'value');

    _defineProperty(this, "_thresholds", []);
  }

  /**
   * The values to be used for the lines.
   * Two dimensional array; the first dimension denotes the index of the line, the second dimension the index of the value.
   * e.g. 'value[2][4]' stores the value of the 5th value within the 3rd line.
   *
   * @default []
   */
  get values() {
    return this._values;
  }

  set values(values) {
    this._values = safeNumberArrays(values);

    this._update();
  }
  /**
   * The labels displayed on each index on the x-axis
   *
   * @default []
   */


  get indexLabels() {
    return this._getCategoryLabels();
  }

  set indexLabels(labels) {
    this._setCategoryLabels(labels);

    this._update();
  }
  /**
   * The indices of the visible lines.
   * If undefined, all lines are visible.
   *
   * Example: `[2, 0, 5]` means that the third, first and sixth line is visible.
   */


  /**
   *
   */
  visibleLinesWatcher() {
    this._update();
  }
  /**
   * If enabled, the legend items can be used to toggle data-series
   */


  /**
   * The icons displayed on the category axis (x-axis)
   *
   * @default []
   */
  get icons() {
    return this._getCategoryIcons();
  }

  set icons(icons) {
    this._setCategoryIcons(icons);

    this._update();
  }

  /**
   * Defines how the lines are styled
   */
  get lineStyles() {
    return this._userDefinedLineStyles;
  }

  set lineStyles(newLineStyles) {
    this._userDefinedLineStyles = ArrayTools.REPLACE_PROPERTIES(this._userDefinedLineStyles, newLineStyles);

    this._update();
  }
  /**
   * Whether tooltips are disabled.
   *
   * @default false (tooltips are enabled by default)
   */


  /**
   *
   */
  noTooltipWatcher() {
    this._update();
  }
  /**
   * The width of the value-axis (in rem)
   *
   * @deprecated use {@link axisWidth} instead
   *
   * @default ValueAxisBuilder.AXIS_DEFAULT_WIDTH
   */


  get valueAxisWidth() {
    return this.axisWidth;
  }

  set valueAxisWidth(value) {
    this.axisWidth = value;
  }
  /**
   * The width of the value-axis (in rem)
   *
   * @default ValueAxisBuilder.AXIS_DEFAULT_WIDTH
   */


  /**
   *
   */
  axisWidthWatcher() {
    this._update();
  }

  /**
   * Determines the visibility of the grid lines.
   *
   * @default value
   */
  get grid() {
    return this._grid;
  }

  set grid(value) {
    this._grid = sanitizeGridVisibility(value);

    this._update();
  }
  /**
   * Customize the lay out the labels and icons of the category axis.
   *
   * @default SpaceGreedily
   */


  get justifyCategoryAxis() {
    return this._justifyCategoryAxis;
  }

  set justifyCategoryAxis(value) {
    this._justifyCategoryAxis = sanitizeJustifyContent(value, 'SpaceGreedily');

    this._update();
  }

  /**
   * The thresholds to be shown
   */
  get thresholds() {
    return this._thresholds;
  }

  set thresholds(value) {
    this._thresholds = value;

    this._update();
  }
  /**
   * Called if palette attribute changes
   */


  paletteWatcher() {
    this._update();
  }
  /**
   *
   */


  _init() {
    var _this$shadowRoot;

    if (!this._api) {
      return;
    }

    const holder = (_this$shadowRoot = this.shadowRoot) === null || _this$shadowRoot === void 0 ? void 0 : _this$shadowRoot.getElementById('holder');

    if (!holder) {
      return;
    }

    holder.appendChild(this._api.holder); // initial update

    this._update();
  }
  /**
   * See base class
   */


  componentFirstRender() {
    this._init();
  }
  /**
   *
   */


  render() {
    var _this$shadowRoot2, _this$legendLabels;

    // recycle holder is needed: holds the actual chart as a child
    let holder = (_this$shadowRoot2 = this.shadowRoot) === null || _this$shadowRoot2 === void 0 ? void 0 : _this$shadowRoot2.getElementById('holder');

    if (!holder) {
      holder = document.createElement('div');
      holder.setAttribute('id', 'holder');
    }

    if (((_this$legendLabels = this.legendLabels) === null || _this$legendLabels === void 0 ? void 0 : _this$legendLabels.length) > 0) {
      const colors = this._values.map((_, i) => {
        var _this$_userDefinedLin, _this$_userDefinedLin2;

        return (_this$_userDefinedLin = (_this$_userDefinedLin2 = this._userDefinedLineStyles[i]) === null || _this$_userDefinedLin2 === void 0 ? void 0 : _this$_userDefinedLin2.lineColor) !== null && _this$_userDefinedLin !== void 0 ? _this$_userDefinedLin : i;
      });

      const symbols = this._values.map((_, i) => {
        var _symbolMap$this$_user, _this$_userDefinedLin3;

        return (_symbolMap$this$_user = symbolMap[(_this$_userDefinedLin3 = this._userDefinedLineStyles[i]) === null || _this$_userDefinedLin3 === void 0 ? void 0 : _this$_userDefinedLin3.lineType]) !== null && _symbolMap$this$_user !== void 0 ? _symbolMap$this$_user : 'line';
      });

      return html`
      <davinci-legend
        placement="N"
        small-font
        compact
        .interactiveLegend=${this.interactiveLegend}
        .symbols=${symbols}
        symbol-size="${CssTools.REM2PIXEL(1.5)}"
        toggle-size="${CssTools.REM2PIXEL(.875)}"
        .labels=${this.legendLabels}
        .palette=${this.palette}
        .colors=${colors}
        @legendStateChanged=${this._handleLegendStateChanged}>
        ${holder}
      </davinci-legend>
      `;
    } else {
      return html`${holder}`;
    }
  }
  /**
   *
   */


  componentConnected() {
    super.componentConnected();
    ThemeService.GET_INSTANCE().addListener(this._themeListener);
    this._api = QuickChart.createLineChartSimple(); // this could be a reattach without a following call for componentFirstRender -> reestablish QuickChart API

    this._init();
  }
  /**
   *
   */


  componentDisconnected() {
    super.componentDisconnected();
    ThemeService.GET_INSTANCE().removeListener(this._themeListener); // We have been detached from the DOM -> clean up

    if (this._api) {
      var _this$shadowRoot3, _this$shadowRoot3$get;

      (_this$shadowRoot3 = this.shadowRoot) === null || _this$shadowRoot3 === void 0 ? void 0 : (_this$shadowRoot3$get = _this$shadowRoot3.getElementById('holder')) === null || _this$shadowRoot3$get === void 0 ? void 0 : _this$shadowRoot3$get.removeChild(this._api.holder);

      this._api.dispose();
    }

    delete this._api;
  }
  /**
   * Updates the line chart
   */


  _update() {
    var _this$shadowRoot4, _this$visibleLines;

    if (this._api === undefined) {
      return;
    }

    const lineChartData = {
      categories: this._computeCategories()
    };

    const computedValueRange = this._computeValueRange();

    this._api.setData(lineChartData);

    const host = (_this$shadowRoot4 = this.shadowRoot) === null || _this$shadowRoot4 === void 0 ? void 0 : _this$shadowRoot4.host;

    if (!host) {
      return;
    }

    const hostFontFamily = CssTools.GET_COMPUTED_FONT_FAMILY(host);
    const style = {
      minDataPointDistance: CssTools.REM2PIXEL(LineChartLayout.VALUE_MIN_DISTANCE),
      maxDataPointDistance: CssTools.REM2PIXEL(LineChartLayout.VALUE_MAX_DISTANCE),
      lineStyles: this._computeLineStyles()
    };
    style.valueRange = computedValueRange;
    style.valuesGridStyle = createValuesGridStyle(this.grid, style.valueRange);
    style.categoriesGridStyle = createCategoriesGridStyle(this.grid);
    const valueAxisBuilder = new ValueAxisBuilder();
    valueAxisBuilder.fontFamily = hostFontFamily;
    valueAxisBuilder.title = this.valueAxisTitle;
    valueAxisBuilder.horizontal = false;
    valueAxisBuilder.maxTickCount = this.valueAxisMaxTickCount;
    valueAxisBuilder.axisWidth = this.axisWidth;
    valueAxisBuilder.shorthandLabels = this.shorthandLabels;
    valueAxisBuilder.decimalPlaces = this.decimalPlaces;
    style.valueAxisStyle = valueAxisBuilder.build();
    const categoryAxisBuilder = new CategoryAxisBuilder();
    categoryAxisBuilder.fontFamily = hostFontFamily;
    categoryAxisBuilder.title = this.categoryAxisTitle;
    categoryAxisBuilder.horizontal = true;
    categoryAxisBuilder.justifyTickContent = this.justifyCategoryAxis;
    categoryAxisBuilder.icons = this._categoryIcons;
    categoryAxisBuilder.labels = this._getCategoryLabels();
    style.categoryAxisStyle = categoryAxisBuilder.build();
    style.categoryAxisStyle.axisLineWidth = 0.0;
    style.thresholds = computeThresholds(this.thresholds, true, hostFontFamily, this.shorthandLabels, this.decimalPlaces);
    style.contentViewportMargin = {
      right: 0
    };
    style.showTooltip = !this.noTooltip;

    if (style.showTooltip) {
      style.tooltipWireStyle = {
        wireColor: resolveCssColor('var(--davinci-color-text-on-background-elements-4)'),
        wireWidth: 1
      };
      style.tooltipStyle = createBalloonTooltipStyle(hostFontFamily, this.shorthandLabels, this.decimalPlaces); // adjust the symbol-size so we have lines instead of squares

      style.tooltipStyle.symbolSizes = [{
        width: CssTools.REM2PIXEL(0.75),
        height: 3
      }];
    }

    style.visibleLines = (_this$visibleLines = this.visibleLines) !== null && _this$visibleLines !== void 0 ? _this$visibleLines : [-1];

    this._api.setStyle(style);
  }
  /**
   *
   */


  *_iterator() {
    for (const lineValues of this._values) {
      for (const value of lineValues) {
        yield value;
      }
    }
  }
  /**
   *
   */


  _computeValueRange() {
    const computedValueRange = ValueRangeTools.COMPUTE_VALUE_RANGE(this._iterator(), this.valueRange);
    return {
      start: computedValueRange.start,
      end: computedValueRange.end,
      scale: computedValueRange.scale === ValueRangeScale.linear ? 'Linear' : 'Log10'
    };
  }
  /**
   *
   */


  _computeCategories() {
    const linesCount = this._values.length;
    let categoriesCount = 0;

    for (let lineIndex = 0; lineIndex < linesCount; lineIndex++) {
      categoriesCount = Math.max(categoriesCount, this._values[lineIndex].length);
    } // initialize categories


    const categories = [];

    for (let categoryIndex = 0; categoryIndex < categoriesCount; categoryIndex++) {
      const categoryData = {
        values: []
      };
      categories.push(categoryData);

      for (let lineIndex = 0; lineIndex < linesCount; lineIndex++) {
        const lineValues = this._values[lineIndex];
        const categoryValue = categoryIndex < lineValues.length ? lineValues[categoryIndex] : NaN;
        categoryData.values[lineIndex] = categoryValue;
      }
    } // category labels


    {
      const minLength = Math.min(categoriesCount, this._getCategoryLabels().length);

      for (let categoryIndex = 0; categoryIndex < minLength; categoryIndex++) {
        categories[categoryIndex].label = this._getCategoryLabels()[categoryIndex];
      }
    } // category icons

    {
      const minLength = Math.min(categoriesCount, this._categoryIcons.length);

      for (let categoryIndex = 0; categoryIndex < minLength; categoryIndex++) {
        categories[categoryIndex].image = this._categoryIcons[categoryIndex];
      }
    }
    return categories;
  }
  /**
   *
   */


  _computeLineStyles() {
    const computedLineStyles = [];

    for (let lineIndex = 0; lineIndex < this.values.length; lineIndex++) {
      var _userDefinedLineStyle;

      const computedLineStyle = {};
      computedLineStyles.push(computedLineStyle);
      const userDefinedLineStyle = this._userDefinedLineStyles[lineIndex % this._userDefinedLineStyles.length] || {};
      const lineColor = (_userDefinedLineStyle = userDefinedLineStyle.lineColor) !== null && _userDefinedLineStyle !== void 0 ? _userDefinedLineStyle : lineIndex;
      const cssColor = isColor(lineColor) ? toCssColorValue(lineColor, this.palette) : null;
      const pointColors1 = ArrayTools.TO_ARRAY(userDefinedLineStyle.pointColor1);

      if (pointColors1) {
        computedLineStyle.pointColor1 = pointColors1.map(value => toCssColorValue(value, this.palette));
      }

      const pointColors2 = ArrayTools.TO_ARRAY(userDefinedLineStyle.pointColor2);

      if (pointColors2) {
        computedLineStyle.pointColor2 = pointColors2.map(value => toCssColorValue(value, this.palette));
      }

      computedLineStyle.lineStyle = {
        color: cssColor,
        width: userDefinedLineStyle.lineWidth,
        type: userDefinedLineStyle.lineType
      };
      computedLineStyle.pointConnectionType = userDefinedLineStyle.connectionType;
      computedLineStyle.pointType = ArrayTools.TO_ARRAY(userDefinedLineStyle.pointType);
      const pointSizes = ArrayTools.TO_ARRAY(userDefinedLineStyle.pointSize);

      if (pointSizes) {
        computedLineStyle.pointSize = pointSizes.map(value => CssTools.REM2PIXEL(value));
      }

      const pointLineWidths = ArrayTools.TO_ARRAY(userDefinedLineStyle.pointLineWidth);

      if (pointLineWidths) {
        computedLineStyle.pointLineWidth = pointLineWidths.map(value => CssTools.REM2PIXEL(value));
      }
    }

    return computedLineStyles;
  }
  /**
   * @param e
   */


  _handleLegendStateChanged(e) {
    const legendState = e.detail;
    this.visibleLines = legendState.filter(state => state.active).map(state => state.index);
  }

}, (_applyDecoratedDescriptor(_class2.prototype, "values", [_dec2, _dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "values"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "indexLabels", [_dec4, _dec5], Object.getOwnPropertyDescriptor(_class2.prototype, "indexLabels"), _class2.prototype), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "visibleLines", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "visibleLinesWatcher", [_dec8, _dec9], Object.getOwnPropertyDescriptor(_class2.prototype, "visibleLinesWatcher"), _class2.prototype), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "interactiveLegend", [_dec10, _dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "icons", [_dec12, _dec13], Object.getOwnPropertyDescriptor(_class2.prototype, "icons"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "lineStyles", [_dec14, _dec15], Object.getOwnPropertyDescriptor(_class2.prototype, "lineStyles"), _class2.prototype), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "noTooltip", [_dec16, _dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "noTooltipWatcher", [_dec18, _dec19], Object.getOwnPropertyDescriptor(_class2.prototype, "noTooltipWatcher"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "valueAxisWidth", [_dec20, _dec21], Object.getOwnPropertyDescriptor(_class2.prototype, "valueAxisWidth"), _class2.prototype), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "axisWidth", [_dec22, _dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return ValueAxisBuilder.AXIS_DEFAULT_WIDTH;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "axisWidthWatcher", [_dec24, _dec25], Object.getOwnPropertyDescriptor(_class2.prototype, "axisWidthWatcher"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "grid", [_dec26, _dec27], Object.getOwnPropertyDescriptor(_class2.prototype, "grid"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "justifyCategoryAxis", [_dec28, _dec29], Object.getOwnPropertyDescriptor(_class2.prototype, "justifyCategoryAxis"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "thresholds", [_dec30, _dec31], Object.getOwnPropertyDescriptor(_class2.prototype, "thresholds"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "paletteWatcher", [_dec32, _dec33], Object.getOwnPropertyDescriptor(_class2.prototype, "paletteWatcher"), _class2.prototype)), _class2)) || _class);
/**
 * Represents the style of a single line
 */
